import { app } from '../app';

app.directive('fileInput', fileInput);

/** @ngInject */
function fileInput() {
        return {
            restrict : 'A',
            require : "ngModel",
            link : function(scope, element, attrs, ngModel) {
                element.bind('change', function(event) {
                    var files = event.target.files;
                    var file = files[0];
                    ngModel.$setViewValue(file);
                    scope.$apply();

                });
            }
        }
}



// WEBPACK FOOTER //
// ./src/portal/directives/file-input.directive.js